export enum AUTH {
  SET_LOGIN_STATUS = "SET_LOGIN_STATUS",
  RESET = "RESET",
  SET_USER_DETAILS = "SET_USER_DETAILS",
  SET_LOADING = "SET_LOADING",
  SET_DATA = "SET_DATA",
  SET_KYC_REQUEST = "SET_KYC_REQUEST",
  SET_FETCHED_DATA = "SET_FETCHED_DATA",
}
